import {
  createAndRetrievePDF,
  removeStoredCertificatesByGuid
} from "./utils/certificate";

document.addEventListener("DOMContentLoaded", async () => {
  const currentURL = new URL(window.location.href);
  if (!currentURL.pathname.includes("/get-pdf")) return;

  const guid = currentURL.searchParams.get("GUID");
  if (!guid) return;

  const getPdf = await createAndRetrievePDF("final", {}, guid);
  const { preview } = getPdf;

  if (!preview) return;

  removeStoredCertificatesByGuid(guid);

  window.location.href = preview;
});
